import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Rx';

@Injectable()

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Sidebar Service.
 */
export class SidebarService
{
	/**
	 * State: Show sidebar?
	 */
	private isOpened = false;

	/**
	 * Subject for shown state.
	 */
	private subject = new Subject<any>();

	/**
	 * Observable for shown state.
	 */
	public sidebarIsOpened = this.subject.asObservable();

	/**
	 * Constructor.
	 */
	public constructor()
	{}

	/**
	 * Toggle state for sidebar.
	 */
	public toggle()
	{
		this.isOpened = !this.isOpened;
		this.subject.next(this.isOpened);
	}

	/**
	 * Close sidebar.
	 */
	public close()
	{
		this.isOpened = false;
		this.subject.next(this.isOpened);
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/services/sidebar.service.ts